import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Container from '@material-ui/core/Container';
import Header from './core/Header/Header'
import Zonic from './feature/Zonic/Zonic'
import Avatar from './feature/Avatar/Avatar'
import AugmentedViewer from './feature/Avatar/AugmentedViewer/AugmentedViewer';
import { disableBodyScroll } from 'body-scroll-lock';
import './App.css';

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.

export default function ZonicApp() {

  const containerStyle = {
    height: '100%',
    paddingLeft:'0px',
    paddingRight: '0px'
  }

  const app: any = React.useRef<HTMLElement>();

  React.useEffect(() => {
    if(app && app.current){
      disableBodyScroll(app.current, {allowTouchMove: app.current});
    }
  }, [])


  return (
      <Router>
        <Header/>
        <div className="App" ref={app}>
          {/*
            A <Switch> looks through all its children <Route>
            elements and renders the first one whose path
            matches the current URL. Use a <Switch> any time
            you have multiple routes, but you want only one
            of them to render at a time
          */}
          <Switch>
            <Route exact path="/">
              <Redirect push to="/zonic" />
            </Route>
            <Route exact path="/zonic">
              <Redirect push to="/zonic/1" />
            </Route>
            <Route exact path="/zonic/:modelId" render={(route) => (
              <Container maxWidth="lg" style={containerStyle}>
                <Zonic id={route.match.params.modelId} />
              </Container>
            )}>
            </Route>
            <Route exact path="/avatar">
              <Container maxWidth="lg" style={containerStyle}>
                <Avatar />
              </Container>
            </Route>
            <Route exact path="/avatar/:modelId" render={(route) => (
                <Container maxWidth="lg" style={containerStyle}>
                  <AugmentedViewer id={route.match.params.modelId}/>
                </Container>
              )} >
            </Route>
            {/* <Route exact path="/impressum">
            </Route> */}
          </Switch>
        </div>
      </Router>
  );
}

// // You can think of these components as "pages"
// // in your app.


// function About() {
//   return (
//     <div>
//       <h2>About</h2>
//     </div>
//   );
// }

// function Dashboard() {
//   return (
//     <div>
//       <h2>Dashboard</h2>
//     </div>
//   );
// }
